module.exports = __webpack_public_path__ + "static/media/BannerPagArco.7bc6832d.png";